export { default as Home } from './Home';
export { default as Presentation } from './Presentation';
export { default as Politique } from './Politique';
export { default as Comites } from './Comites';
export { default as Credits } from './Credits';
export { default as Proposition } from './Proposition';
export { default as Search } from './Search';
export { default as Article } from './Article';
export { default as ArticleDetails } from './ArticleDetails';
export { default as Rubrique } from './Rubrique';
export { default as Login } from './Login';